import { cn } from '../../utils.js';

/**
 * Where you are in the monthly upload, and what is still ahead.
 *
 * The flow deliberately has a middle: files are read, then checked, then
 * published. Without the steps drawn out, "קרא קבצים" looks like it might be the
 * thing that updates the client — which is exactly the fear this flow exists to
 * remove.
 */
export interface FlowStep {
  id: string;
  label: string;
}

export function FlowSteps({ steps, current }: { steps: FlowStep[]; current: string }) {
  const at = Math.max(0, steps.findIndex((s) => s.id === current));
  return (
    <ol className="flex flex-wrap items-center gap-x-2 gap-y-2 text-sm" aria-label="שלבי הקליטה">
      {steps.map((s, i) => {
        const done = i < at;
        const active = i === at;
        return (
          <li key={s.id} className="flex items-center gap-2">
            <span
              className={cn(
                'flex items-center gap-2 rounded-full py-1 pe-3 ps-1.5',
                active && 'bg-secondary font-semibold text-foreground',
                !active && 'text-muted-foreground',
              )}
              aria-current={active ? 'step' : undefined}
            >
              <span
                className={cn(
                  'flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-xs tabular-nums',
                  done && 'bg-success/20 text-success',
                  active && 'bg-primary text-primary-foreground',
                  !done && !active && 'border border-border',
                )}
              >
                {done ? '✓' : i + 1}
              </span>
              {s.label}
            </span>
            {i < steps.length - 1 && (
              <span aria-hidden className="text-muted-foreground/50">–</span>
            )}
          </li>
        );
      })}
    </ol>
  );
}
